
/*!
 * vue-highlight-words  v2.0.0
 * © 2021 Yichang Liu
 * LICENCE: MIT
*/

import { h } from 'vue';
import { findAll } from 'highlight-words-core';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var VueHighlightWords = function VueHighlightWords(props, context) {
  var chunks = findAll({
    autoEscape: props.autoEscape,
    caseSensitive: props.caseSensitive,
    findChunks: props.findChunks,
    sanitize: props.sanitize,
    searchWords: props.searchWords,
    textToHighlight: props.textToHighlight
  });

  if (props.custom) {
    var slots = context.slots;
    var textArr = getTextChildren(props, chunks, function (chunk, text, attrs) {
      return {
        chunk: chunk,
        text: text,
        attrs: attrs
      };
    });
    return slots.default && slots.default(textArr);
  }

  return h('span', _objectSpread2({}, context.attrs), getTextChildren(props, chunks, function (chunk, text, attrs) {
    if (!chunk.highlight) {
      return text;
    }

    return h('mark', attrs, [text]);
  }));
};

var EMPTY_STYLE = {};

function getTextChildren(props, chunks, callbackFn) {
  var highlightCount = -1;
  var highlightClassNames = '';
  var highlightStyles = {};
  var textToHighlight = props.textToHighlight,
      highlightClassName = props.highlightClassName,
      _props$highlightStyle = props.highlightStyle,
      highlightStyle = _props$highlightStyle === void 0 ? EMPTY_STYLE : _props$highlightStyle,
      activeIndex = props.activeIndex,
      activeClassName = props.activeClassName,
      _props$activeStyle = props.activeStyle,
      activeStyle = _props$activeStyle === void 0 ? EMPTY_STYLE : _props$activeStyle;
  return chunks.map(function (chunk, index) {
    var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);

    if (!chunk.highlight) {
      return callbackFn(chunk, text);
    } else {
      highlightCount++; // start at 0

      var isActive = highlightCount === +(activeIndex || -1);
      highlightClassNames = "".concat(highlightClassName, " ").concat(isActive ? activeClassName : '');
      highlightStyles = isActive === true && activeStyle != null ? _objectSpread2(_objectSpread2({}, highlightStyle), activeStyle) : highlightStyle;
      var attrs = {
        class: highlightClassNames,
        key: index,
        style: highlightStyles,
        highlightIndex: highlightCount
      };
      return callbackFn(chunk, text, attrs);
    }
  });
}

VueHighlightWords.props = {
  activeClassName: String,
  activeIndex: Number,
  activeStyle: Object,
  autoEscape: Boolean,
  caseSensitive: {
    type: Boolean,
    defualt: false
  },
  findChunks: Function,
  custom: {
    type: Boolean,
    default: false
  },
  highlightClassName: String,
  highlightStyle: Object,
  sanitize: Function,
  searchWords: {
    type: Array,
    // Array<string>
    validator: function validator(value) {
      return value.every(function (word) {
        return typeof word === 'string';
      });
    },
    required: true
  },
  textToHighlight: {
    type: String,
    required: true
  }
};
var VueHighlightWords$1 = VueHighlightWords;

function install(app) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  app.component(options.name || 'VueHighlightWords', VueHighlightWords$1);
}

export { VueHighlightWords$1 as VueHighlightWords, VueHighlightWords$1 as default, install };
